/**
 * OdysseyTales's words (ADR-119 decision 1): the bundled English catalogue, typed, so `say` from
 * `daedalus-core/words` checks a key and its parameters at compile time. The page, the gateway, the map server, the
 * mail Worker and tools import this; `odyssey-shared` and Daedalus never do.
 */

import type { Catalogue, WordKey } from "daedalus-core/words";
import { EN_WORDS } from "./en/index.ts";

/**
 * The English catalogue: the fallback of every `say`, and the active catalogue while English is the only language.
 */
export const EN = { locale: "en", words: EN_WORDS } as const satisfies Catalogue;

/**
 * A key of the English catalogue.
 */
export type EnKey = WordKey<typeof EN>;
